export const getCommentsCountFragment = () => `
  comments {
    currentEdition {
      count
    }
  }
`
